export const colors = {
  primary: '#768d2f',
  primaryHover: '#647a1c',
  secondary: '#859e3b',
  secondaryHover: '#7a8f35',
  
  surface: {
    primary: '#ffffff',
    secondary: '#f8f8f7'
  },
  
  text: {
    primary: '#333333',
    secondary: '#666666',
    muted: '#999999',
    inverse: '#ffffff'
  },
  
  border: {
    primary: '#e9e9e9',
    secondary: 'rgba(0, 0, 0, 0.08)'
  },
  
  shadow: {
    menu: 'rgba(0, 0, 0, 0.1)'
  }
} as const

export type Colors = typeof colors